import { render, staticRenderFns } from "./EditResultat.vue?vue&type=template&id=51196f86&scoped=true"
import script from "./EditResultat.vue?vue&type=script&lang=js"
export * from "./EditResultat.vue?vue&type=script&lang=js"
import style0 from "./EditResultat.vue?vue&type=style&index=0&id=51196f86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51196f86",
  null
  
)

export default component.exports